import { __awaiter, __generator } from "tslib";
import { getExternalContext } from 'shared/utils/placement';
export function siteInfoLoader() {
    return __awaiter(this, void 0, void 0, function () {
        var retrieveSiteInfo, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (getExternalContext().dspName !== 'gam') {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, import(
                        /* webpackChunkName: "owned" */ './siteInfo')];
                case 2:
                    retrieveSiteInfo = (_a.sent()).retrieveSiteInfo;
                    return [4 /*yield*/, retrieveSiteInfo()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
